var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGrouppedFrame(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 15,
    viewBox: "0 0 12 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_28327_199288)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.41327 4.09018C6.28299 4.03075 6.14147 4 5.99827 4C5.85508 4 5.71355 4.03075 5.58327 4.09018L1.29827 6.04018C1.20955 6.0793 1.13411 6.14338 1.08115 6.22461C1.0282 6.30584 1 6.40071 1 6.49768C1 6.59465 1.0282 6.68952 1.08115 6.77075C1.13411 6.85198 1.20955 6.91606 1.29827 6.95518L5.58827 8.91018C5.71855 8.9696 5.86008 9.00036 6.00327 9.00036C6.14647 9.00036 6.28799 8.9696 6.41827 8.91018L10.7083 6.96018C10.797 6.92106 10.8724 6.85698 10.9254 6.77575C10.9784 6.69452 11.0065 6.59965 11.0065 6.50268C11.0065 6.40571 10.9784 6.31084 10.9254 6.22961C10.8724 6.14838 10.797 6.0843 10.7083 6.04518L6.41327 4.09018Z",
    stroke: "#9CA3AF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 9C0.999765 9.09563 1.02696 9.18933 1.07836 9.26997C1.12976 9.35062 1.20321 9.41483 1.29 9.455L5.59 11.41C5.7196 11.4687 5.86023 11.499 6.0025 11.499C6.14477 11.499 6.2854 11.4687 6.415 11.41L10.705 9.46C10.7935 9.42022 10.8685 9.35555 10.9209 9.27387C10.9733 9.19219 11.0008 9.09703 11 9",
    stroke: "#9CA3AF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 11.5C0.999765 11.5956 1.02696 11.6893 1.07836 11.77C1.12976 11.8506 1.20321 11.9148 1.29 11.955L5.59 13.91C5.7196 13.9687 5.86023 13.999 6.0025 13.999C6.14477 13.999 6.2854 13.9687 6.415 13.91L10.705 11.96C10.7935 11.9202 10.8685 11.8555 10.9209 11.7739C10.9733 11.6922 11.0008 11.597 11 11.5",
    stroke: "#9CA3AF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_28327_199288"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 14.9984,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrouppedFrame);
export default __webpack_public_path__ + "static/media/grouppedFrame.e0f8708a0ce7dbbcf2f8470fc88b4510.svg";
export { ForwardRef as ReactComponent };